import { ParsedQs } from 'qs';

export const getParsedSearchParams = (searchParams: ParsedQs) =>
  Object.keys(searchParams).reduce((params: string[][], key) => {
    if (Array.isArray(searchParams[key])) {
      const arrayValue: string[][] = [];

      (searchParams[key] as string[]).forEach((value) => {
        arrayValue.push([key, value]);
      });

      return [...params, ...arrayValue];
    }

    return [...params, [key, String(searchParams[key])]];
  }, []);
